export function getOperationTypeNameById(id) {
  if (id === '1') {
    return 'Venta';
  }
  if (id === '2') {
    return 'Alquiler';
  }
  if (id === '4') {
    return 'Alquiler Temporada';
  }
  return '';
}

export function getPropertyNameById(list = [], id) {
  if (list && list.length > 0) {
    const foundObj = list.filter(obj => obj.realEstateTypeId === id);
    return foundObj.length > 0 ? foundObj[0].name : '';
  }
  return '';
}

export function getSubPropertyNameById(list = [], id) {
  if (list && list.length > 0) {
    const foundObj = list.filter(obj => obj.realEstateSubTypeId === id);
    return foundObj.length > 0 ? foundObj[0].name : '';
  }
  return '';
}
